fx.ns("desktop.frame", class FrameEditor extends fx.Component {
    
	constructor(data)
	{
		super(data);
	}

	contextMenu(e)
	{
        return [];
	}

	create()
	{
		super.create();

		this.mediaTabs = new desktop.frame.MediaTabs( this.data );
        this.addChild(this.mediaTabs, {top:0,left:0,width:340,height:"100%"});

		this.board = new desktop.frame.FrameBoard(this.data, desktop.frame.ComponentFactory);
		this.addChild(this.board, {top:0,left:340,width:"100%",height:"100%"});
		
		this.topBar = new desktop.common.actionbar.TopBar( this.data.creation);
		this.addChild(this.topBar,  {top:20,right:25,width:100});

		this.actionBar = new desktop.common.actionbar.ActionBar( this.data);
		this.addChild(this.actionBar,  {top:"center",right:25,width:70});

		this.topNotifications = new desktop.frame.TopNotifications(this.data);
		this.topNotifications.visibleAtStart = false;
		this.addChild(this.topNotifications, {top : 10, right : 25});

		this.dragger = new desktop.common.behaviour.ComponentDragger( this.data, this );
	
        this._optionSelectContainer = new fx.components.Box();
        this._optionSelectContainer.effect = "scroll";
        this._optionSelect = new fx.components.LinkButton({icon : fx.get("assets").editIcon, iconPosition : "left", className : "cover-select"});
        this._optionSelect.toolTip = fx.text("Cliquez pour changer la taille ou la couverture");
        this._optionSelectContainer.addChild( this._optionSelect , {width : "auto", top : 0, left : "center"});
        this.addChild( this._optionSelectContainer );

        if (fx.get("mode") == "creating")
        {
            if (this.data.photos.length == 1)
            {
                // add the photo directly to Frame
                let layout = this.data.layouts.getDefaultLayout();	
                if (layout)
                {
                    this.data.frame.framePage.applyLayout( layout, this.data.frame.pageWidth, this.data.frame.pageHeight);
                    this.data.frame.framePage.photosComponents.getItemAt(0).content = this.data.photos.getItemAt(0).id;
                }
            }
        }
	}

	onDisplayUpdated()
    {
		if (this._optionSelectContainer)
            this._optionSelectContainer.viewport({ width : this.board.realWidth - this.topBar.realWidth - this.topBar.right(), height : 50, top : 10, left : this.board.left()});
    }

	onReady()
	{
		super.onReady();

		this.on("currentAreaChanged", this.onCurrentAreaChanged, this.board);
		this.on("currentElementChanged", this.onCurrentElementChanged, this.board);

		this.on("photo-extracted", this._onPhotoExtractedFinished, fx.service("MediasUploader").photoExtractor);

		if (this.mediaTabs)
			this.mediaTabs.currentArea = this.board.currentArea;

        this.on("scrolled", this._onScroll, this.board);
		
		this.on("order", this._onOrder, this.topBar);
        this.on("exit", this._onExit, this.topBar);

        if (this._optionSelect)
			this.on("click", this._onFrameChoice, this._optionSelect);


		this.listenUpdates(this.data.creation, true);

		this._updateCreationLabel();

		this.data.creation.deleted = 0;
		
        this.data.history.clear();
	
        this.delay(this._setWelcomeTips, 500);
    }

	show(callback)
	{
		super.show(callback);
		fx.set("mode", "edition");
	}

    _onScroll()
	{
		if (this._optionSelectContainer)
			this._optionSelectContainer.toggle(this.board.scrollTop <= 30 && this.data.zoom.value == 100);
	}

    _onOrder()
    {
        this.data.event("order");
    }

    _onExit()
    {
        this.data.event("exit-editor");
    }

    _onFrameChoice()
    {
        this.data.event("frame-choice");
    }
	
	enable()
	{
		super.enable();
		this.board.enable();
	}

	disable()
	{
		super.disable();
		this.board.disable();
	}

	onCurrentAreaChanged(e)
	{
		if (this.mediaTabs)
			this.mediaTabs.currentArea = e.detail;
	}

	onCurrentElementChanged(e)
	{
		// nothing to do
	}

	onDataEvent(e)
	{
		switch(e.type)
		{
			case "switch-photoPanel":
				this.mediaTabs.tabs.selectTab(this.mediaTabs.photoPanel);
				break;

			case "currentAreaChanged" :
				this.onCurrentAreaChanged(e);
				break;

		}
	}

    onChildUpdated(action)
    {
        if (action.model instanceof models.ProductFrame)
            this.delay(this._updateCreationLabel, 250);
    }

    onDataUpdated(action)
    {
        if (action.model instanceof models.ProductFrame)
            this.delay(this._updateCreationLabel, 250);
    }
    
    _updateCreationLabel()
    {
		if (!this._optionSelect) return;

        this._optionSelect.label = this.data.creation.format.name + ", " + this.data.creation.format.description ; ;
    }

    _setWelcomeTips()
    {
        fx.service("WelcomeTips", {model :this.data, editor : this});
         
        let notifications = [];

		if (this.data.photos.length<=0  && this.data.photos.length<=0)
        	notifications.push( {trigger:"choose-photos", forbidenComponentClass : "PopupPanel", component : this.mediaTabs.photoPanel.button, title :  fx.text("On Commence ?"), text :  fx.text("Ajoutez vos photos<br>en cliquant ici"), always : true, start : true } );

        notifications.push( {trigger:"photo-selected", forbidenComponentClass : "PopupPanel", title :  fx.text("Besoin de Recadrer ?"), text :  fx.text("Appuyez une seconde fois<br>sur la photo."), width : 320 } );
        notifications.push( {trigger:"first-updates", component : this.actionBar.undoButton, title :  fx.text("Au cas ou..."), text :  fx.text("Vous pouvez annulez vos<br>modifications ici") } );

        fx.service("WelcomeTips").notifications( notifications );    
    }

});